module.exports = __webpack_public_path__ + "img/indicado_epocaNegocios-v2.d158680e.png";